<ion-header>
  <ion-toolbar class="header-color">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="home"></ion-back-button>
    </ion-buttons>
    <ion-title>Instructor's Activities</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="ion-text-center" style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 80vh;">

    <ion-icon name="desktop-outline" style="font-size: 64px; color: #3880ff;"></ion-icon>

    <ion-card color="light" style="max-width: 400px; margin-top: 20px; box-shadow: 0 4px 16px rgba(0,0,0,0.1); border-radius: 16px;">
      <ion-card-header>
        <ion-card-title class="ion-text-center" style="font-size: 1.2rem; font-weight: bold;">Available on Desktop Only</ion-card-title>
      </ion-card-header>
      <ion-card-content style="font-size: 1rem; padding: 16px;">
        The <strong>Instructor's Activities</strong> menu is only accessible on our desktop site.
        <br><br>
        Please visit <b>promoga.com</b> on a <b>desktop computer</b> to log in and access this feature.
      </ion-card-content>
    </ion-card>

  </div>
</ion-content>
